import './utils/bufferPolyfill'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { i18nPlugin } from './i18n'
import { persistEmbedParamsFromSearch } from './utils/embedParams'
import { assertBip39EngineReady, getBip39Diagnostics } from './utils/mnemonicValidator'

persistEmbedParamsFromSearch()

if (!assertBip39EngineReady()) {
  console.error('[mnemonic] BIP39 引擎自检失败', getBip39Diagnostics())
}

createApp(App).use(i18nPlugin).use(router).mount('#app')
